import React from 'react'
import UserType from '../../../components/topNavigationComp/customer/userType/UserType'
import Breadcrumbs from '../../../common/breadcrumb/Breadcrumbs'

const UsersType = () => {
  return (
    <>
           <Breadcrumbs breadCrumbsTitle={{
    id: "1",
    title_1: "Help & Support",
    title_2: "User Type",
  }} />

      <UserType/>
    </>
  )
}

export default UsersType
